export default "__VITE_ASSET__c0908318__"